import * as React from "react";
const SvgFiRrChooseAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M9.5 2.5A2.5 2.5 0 1 1 13 4.789V6a1 1 0 1 1-2 0V4.789A2.5 2.5 0 0 1 9.5 2.5m9.23 16.041L15 17.282v-5.175c0-1.516-1.076-2.835-2.503-3.067a3 3 0 0 0-2.439.674A3 3 0 0 0 9 12v7.563l-1.039-.82a2.995 2.995 0 0 0-4.022 4.438l.558.538c.186.18.435.28.694.28.9 0 1.342-1.095.694-1.72l-.568-.548a1.001 1.001 0 0 1 1.364-1.464l1.771 1.414c.476.38 1.111.45 1.66.187.548-.265.889-.807.889-1.415v-8.454a1.002 1.002 0 0 1 1.175-.986c.463.075.825.555.825 1.093v5.893c0 .429.273.811.681.947l4.38 1.478a3 3 0 0 1 1.941 2.634 1 1 0 0 0 .997.941q.03 0 .06-.002a1 1 0 0 0 .939-1.057 5.01 5.01 0 0 0-3.268-4.4zm-1.922-9.079c.204 0 .41-.062.588-.191l.85-.619c.37.216.794.349 1.254.349a2.5 2.5 0 1 0-2.438-1.961l-.843.614a1 1 0 0 0 .589 1.808M5.753 8.651l.85.619a1 1 0 0 0 1.398-.22 1 1 0 0 0-.22-1.397l-.843-.614C6.976 6.865 7 6.685 7 6.5A2.5 2.5 0 1 0 4.5 9c.459 0 .884-.133 1.254-.349z"
    />
  </svg>
);
export default SvgFiRrChooseAlt;
